namespace GeniuzPOS.Product {
    export class CsCategoryColumns {
        static columnsKey = 'Product.CsCategory';
    }
}
